export default __webpack_public_path__ + "static/favicon-167-4fd3eab32f19a0f9ef951b9bdafb6abd.png";